<template>
  <div class="main-box">
    <el-form class="form-inline" :inline="true">
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入关键词" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="handleSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        ref="rfTable"
        border
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="100">
      </el-table-column>
      <el-table-column
          prop="share_member"
          label="邀请会员"
          align="center"
          width="240">
        <template slot-scope="scope">
          <div class="member-box" v-if="scope.row.share_member_user_id">
            <img :src="scope.row.share_member_avatar" />
            <div>
              <div>{{scope.row.share_member_name}}（{{scope.row.share_member_user_id}}）</div>
              <div>{{scope.row.share_member_mobile}}</div>
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="member"
          label="申请会员"
          align="center"
          width="240">
        <template slot-scope="scope">
          <div class="member-box">
            <img :src="scope.row.member_avatar" />
            <div>
              <div>{{scope.row.member_name}}（{{scope.row.member_user_id}}）</div>
              <div>{{scope.row.member_mobile}}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="name"
          label="姓名"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          prop="store_name"
          label="门店名称"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          prop="address"
          label="地址"
          align="left"
          min-width="120">
        <template slot-scope="scope">
          <div>{{scope.row.province_name}}{{scope.row.city_name}}{{scope.row.district_name}}{{scope.row.address}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="status"
          label="审核状态"
          align="center"
          width="120">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.status == 1" type="success">审核通过</el-tag>
          <el-tag size="mini" v-if="scope.row.status == 2" type="danger">审核未通过</el-tag>
          <el-tag size="mini" v-if="scope.row.status == 0">待审核</el-tag>
          <div v-if="scope.row.status==2">原因：{{scope.row.apply_remark}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="apply_time"
          label="审核时间"
          align="center"
          width="140">
        <template slot-scope="scope">
          {{scope.row.apply_time ?? '-'}}
        </template>
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="提交时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="120">
        <template slot-scope="scope">
            <el-button type="text" size="small" @click="showBox(scope.row)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, jumper"
        :page-sizes="[15, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
    <el-dialog
        title="审核门店"
        :visible.sync="showDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="applyInfo" label-position="right" ref="ruleForm" label-width="60px" class="ruleForm" size="small">
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="applyInfo.status">
            <el-radio :label="item.id" v-for="(item,index) in statusList" :key="index" :value="item.id">{{item.title}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="applyInfo.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveApply()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      info: false,
      source_domain: this.config.SOURCE_DOMAIN,
      showDialog: false,
      applyInfo: {
        id: '',
        status: '',
        remark: ''
      },
      statusList: [
        {id: 1, title: '通过'},
        {id: 2, title: '拒绝'},
      ],
      search: {
        current_page: 1,
        total: 0,
        limit: 15,
        keywords: ''
      },
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    showBox(item) {
      this.$router.push({name: 'sys_store_apply_info', query: {id: item.id}})
      // this.applyInfo.id = item.id
      // this.applyInfo.status = ''
      // this.applyInfo.remark = ''
      // this.showDialog = true
    },
    saveApply() {
      if(this.applyInfo.status=='') {
        this.fail('请选择审核状态')
        return false
      }
      if(this.applyInfo.status==2 && this.applyInfo.remark=='') {
        this.fail('请填写拒绝理由')
        return false
      }
      this.$api.merchant.storeShenhe(this.applyInfo, res => {
        if(res.errcode == 0) {
          this.success('保存成功')
          this.showDialog = false
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords
      }
      this.$api.merchant.storeIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
